import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import * as L from 'leaflet';
import { icon, Marker } from 'leaflet';

@Injectable({
  providedIn: 'root'
})
export class MapStyleService {

  constructor(private translate: TranslateService) { }

  getIconMarker():Marker{
    const iconRetinaUrl = 'assets/marker-icon-2x.png';
    const iconUrl = 'assets/marker-icon.png';
    const shadowUrl = 'assets/marker-shadow.png';
    const iconDefault = icon({
      iconRetinaUrl,
      iconUrl,
      shadowUrl,
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      tooltipAnchor: [16, -28],
      shadowSize: [41, 41]
    });
    Marker.prototype.options.icon = iconDefault;
  }


  getDrawControlPersonalized(): L.Control.Draw {
    const drawnItems = new L.FeatureGroup();
    const customMarker = L.Icon.extend({
      options: {
          shadowUrl: null,
          iconAnchor: new L.Point(12, 12),
          iconSize: new L.Point(24, 24),
          iconUrl: 'assets/images/edit_farm.svg'
      }
    });

    const drawControl = new L.Control.Draw({
      draw : {
        position : 'topleft',
        polygon : {
          shapeOptions: {
            color: 'red'
          }
        },
        marker: {
          icon: new customMarker() //Here assign your custom marker
        },
        polyline : false,
        rectangle : {
          shapeOptions: {
            color: 'blue'
          }
        },
        circle : false
      },
      edit: {
        featureGroup: drawnItems, //REQUIRED!!
        remove: true
      }
    });
    return drawControl;

  }

  getStyleFor(): any {
    const customIcon = {
      iconSize: [25, 25],
      iconAnchor: [12, 12]
    }
    return { icon: L.icon(customIcon) };
  }

  getStylesToolbar(){
    return L.drawLocal.edit = {
      toolbar: {
        actions: {
          save: {
            title: this.translate.instant('SAVE_CHANGES'),
            text: this.translate.instant('SAVE')
          },
          cancel: {
            title: this.translate.instant('CANCEL_TITLE'),
            text: this.translate.instant('CANCEL')
          },
          clearAll: {
            title: this.translate.instant('FARM.DRAW.DELETE_FARM'),
            text: this.translate.instant('DELETE_ALL')
          }
        },
        buttons: {
          edit: this.translate.instant('FARM.DRAW.EDIT_FARM'),
          editDisabled: this.translate.instant('FARM.DRAW.NO_EDIT_FARM'),
          remove: this.translate.instant('FARM.DRAW.DELETE_FARM'),
          removeDisabled: this.translate.instant('FARM.DRAW.NO_DELETE_FARM')
        }
      },
      handlers: {
        edit: {
          tooltip: {
            text: this.translate.instant('HANDLERS.EDIT'),
            subtext: 'Click cancel to undo changes.'
          }
        },
        remove: {
          tooltip: {
            text: this.translate.instant('HANDLERS.REMOVE')
          }
        }
      }
    }
  }

  getDrawControlFarms(drawnItems: L.featureGroup, isEdit: boolean): L.Control.Draw{
    const optionsDraw = {
      position: 'topleft',
      draw: {
          polygon: isEdit ? undefined : {
              allowIntersection: false, // Restricts shapes to simple polygons
              showArea: true,
              // drawError: {
              //     color: '#e1e100', // Color the shape will turn when intersects
              //     message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
              // },
              shapeOptions: {
                weight: 5,
                color: '#000000'
              },
          },
          circle: false,
          circlemarker: false,
          marker: false,
          polyline: false,
          rectangle: false,
          handlers: {
            polygon: {
              tooltip : {
                start: 'Click to start drawing your farm.',
                cont: 'Click to continue drawing your farm.',
                end: 'Click the first point to close the boundary of your farm.'
              }
            }
          }
    },
      edit: {
          featureGroup: drawnItems, //REQUIRED!!
          remove: !isEdit
      }
    };
    return new L.Control.Draw(optionsDraw);
  }

  public getDrawCustomOptions() {
    L.drawLocal.draw.toolbar.buttons.polygon = this.translate.instant('FARM.DRAW.FARM');
    L.drawLocal.draw.handlers.polygon.tooltip = {
      start: this.translate.instant('FARM.DRAW.TOOLTIP.START'),
      cont: this.translate.instant('FARM.DRAW.TOOLTIP.CONT'),
      end: this.translate.instant('FARM.DRAW.TOOLTIP.END')
    };

    L.drawLocal.draw.toolbar = {
			actions: {
				title: this.translate.instant('FARM.DRAW.ACTIONS_TITLE'),
				text: this.translate.instant('CANCEL')
			},
			finish: {
				title: this.translate.instant('FARM.DRAW.FINISH_TITLE'),
				text: this.translate.instant('SYSTEM.DONE')
			},
			undo: {
				title: this.translate.instant('FARM.DRAW.UNDO_TITLE'),
				text: this.translate.instant('FARM.DRAW.END')
			},
			buttons: {
				polyline: 'Draw a polyline',
				polygon: this.translate.instant('FARM.DRAW.FARM'),
				rectangle: 'Draw a rectangle',
				circle: 'Draw a circle',
				marker: 'Draw a marker',
				circlemarker: 'Draw a circlemarker'
			}
    }
    L.drawLocal.edit = {
      toolbar: {
        actions: {
          save: {
            title: this.translate.instant('SAVE_CHANGES'),
            text: this.translate.instant('SAVE')
          },
          cancel: {
            title: this.translate.instant('CANCEL_TITLE'),
            text: this.translate.instant('CANCEL')
          },
          clearAll: {
            title: this.translate.instant('FARM.DRAW.DELETE_FARM'),
            text: this.translate.instant('DELETE_ALL')
          }
        },
        buttons: {
          edit: this.translate.instant('FARM.DRAW.EDIT_FARM'),
          editDisabled: this.translate.instant('FARM.DRAW.NO_FARMS_FOR_EDIT'),
          remove: this.translate.instant('FARM.DRAW.DELETE_FARM'),
          removeDisabled: this.translate.instant('FARM.DRAW.NO_FARMS_FOR_DELETE')
        }
      },
      handlers: {
        edit: {
          tooltip: {
            text: this.translate.instant('HANDLERS.EDIT'),
            subtext: 'Click cancel to undo changes.'
          }
        },
        remove: {
          tooltip: {
            text: this.translate.instant('HANDLERS.REMOVE')
          }
        }
      }
    };
  }
}